import React from 'react';
import { useLoadUserQuery } from '@diditusa/shared/api/sessionApi';

const styles = {
  container: {
    maxWidth: '700px',
    margin: '3rem auto',
    padding: '2rem 2.5rem',
    fontFamily: "'Nunito', sans-serif",
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    boxShadow: '0 6px 20px rgba(0, 0, 0, 0.1)',
    border: '1px solid #e5e7eb',
  },
  header: {
    textAlign: 'center',
    fontSize: '1.75rem',
    fontWeight: 800,
    color: '#111827',
    borderBottom: '1px solid #e5e7eb',
    paddingBottom: '0.75rem',
    marginBottom: '2rem',
  },
  fieldGroup: {
    marginBottom: '1.5rem',
  },
  label: {
    display: 'block',
    fontWeight: 600,
    marginBottom: '0.25rem',
    color: '#374151',
    fontSize: '0.95rem',
  },
  valueBox: {
    padding: '0.75rem',
    backgroundColor: '#f9fafb',
    borderRadius: '8px',
    border: '1px solid #d1d5db',
    fontSize: '1rem',
    color: '#111827',
  },
};

const AccountPage = () => {
  const { data: user, isLoading } = useLoadUserQuery();

  if (isLoading) return <p style={{ textAlign: 'center' }}>Loading account details...</p>;

  return (
    <div style={styles.container}>
      <h1 style={styles.header}>My Account</h1>

      <div>
        <img
          // src={user.imageUrl}
          alt='User Avatar'
          style={{
            width: '100px',
            height: '100px',
            borderRadius: '50%',
            objectFit: 'cover',
          }}
        />
      </div>

      <div style={styles.fieldGroup}>
        <label style={styles.label}>First Name</label>
        <div style={styles.valueBox}>{user?.firstName || '-'}</div>
      </div>

      <div style={styles.fieldGroup}>
        <label style={styles.label}>Last Name</label>
        <div style={styles.valueBox}>{user?.lastName || '-'}</div>
      </div>

      <div style={styles.fieldGroup}>
        <label style={styles.label}>Email</label>
        <div style={styles.valueBox}>{user?.email || '-'}</div>
      </div>
    </div>
  );
};

export default AccountPage;
